<template>
  <div class="form-check" :class="{'is-invalid': invalid}" v-for="option in options" :key="option.id">
      <input
        type="checkbox"
        class="form-check-input"
        :id="option.id"
        :class="{'is-invalid': invalid}"
        :checked="checked[option.id]"
        :disabled="option.disabled"
        @change="doChange(option.id, $event.target.checked)">
      <label class="form-check-label"
        :for="option.id"
        :class="{'disabled-label': option.disabled}">
        {{ option.text }}
      </label>
  </div>

</template>
<script>
export default {
  name: 'CheckBoxList',
  props: {
    modelValue: {
      type: Object,
      default: () => {return {}},
    },
    options: {
      type: Array,
      required: true
    },
    invalid: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  computed: {
    checked() {
      return this.options.reduce((acc, option) => {
        acc[option.id] = this.modelValue[option.id] ?? option.checked ?? false;
        return acc;
      }, {});
    },
  },
  methods: {
    doChange(id, value) {
      const updatedValues = { ...this.modelValue, [id]: value };
      this.$emit("update:modelValue", updatedValues);
    },
  },
}
</script>

<style scoped>
/* チェックボックスが非活性でもラベルの色を変更しない */
.form-check-input:disabled + .form-check-label {
  color: inherit !important;
  opacity: 1 !important;
}
</style>